'use client';

import ParallaxMedia from '@components/parallax-media/ParallaxMedia';
import Gradient_4_mob from '@images/gradients/gradient_4_mob.webp';
import Gradient_5 from '@images/gradients/gradient_5.webp';
import { ScrollTrigger } from '@lib/tools/gsap-init';
import { scrollInfrastructure } from '@lib/tools/helpers/constants';
import { SafeHtmlRenderer } from '@lib/tools/helpers/SafeHtmlRenderer';
import { useViewport } from '@lib/tools/hooks/useViewport';
import cn from 'classnames';
import gsap from 'gsap';
import NextImage from 'next/image';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import style from './HorizontalScrollInfra.module.scss';

function HorizontalScroll() {
  const [st1, setSt1] = useState(null);
  const [st2, setSt2] = useState(null);
  const [st3, setSt3] = useState(null);
  const [st4, setSt4] = useState(null);

  const [classNames, setClassNames] = useState(style.horizontalScrollContainer);

  const scrollRef = useRef(null);
  const horizontalRef = useRef(null);

  const { isMobile, isTablet, viewport, isPortrait, isLandscape, userAgent } = useViewport();

  const hasRefs = scrollRef.current && horizontalRef.current;
  const isSmallDevice = isMobile || isTablet;
  const isOrientationValid = isPortrait || (isLandscape && userAgent === 'none');

  useLayoutEffect(() => {
    if (hasRefs && isSmallDevice && isOrientationValid) {
      setClassNames(prev => cn(prev, style.__horizontalScroll));

      setTimeout(() => {
        scrollInfrastructure.forEach((_, index) => {
          let rotateN;
          if (scrollInfrastructure[index].rotate > 0) rotateN = 6;
          else rotateN = -6;
          setSt4(
            ScrollTrigger.create({
              animation: gsap.to(horizontalRef.current.children[index], {
                rotate: `${scrollInfrastructure[index].rotate + rotateN}deg`,
                ease: 'slow',
              }),
              trigger: scrollRef.current,
              start: 'bottom bottom',
              scroller: '.horizontal',
              horizontal: true,
              scrub: true,
            }),
          );
          return null;
        });
      }, 1000);
    }
  }, [viewport, scrollRef, horizontalRef, isPortrait, userAgent]);

  useEffect(() => {
    return () => {
      st1?.kill();
      st2?.kill();
      st3?.kill();
      st4?.kill();
      setSt1(null);
      setSt2(null);
      setSt3(null);
      setSt4(null);
    };
  }, []);

  return (
    <div className={cn(classNames, 'horizontal')} ref={scrollRef}>
      {scrollInfrastructure && (
        <div className={style.horizontalScrollWrapperMob} ref={horizontalRef}>
          {scrollInfrastructure.map(item => (
            <div
              key={item.src}
              className={cn(style.horizontalScrollItem, item.style)}
              style={{
                transform: `rotate(${item.rotate}deg)`,
                top: `${item.top}%`,
              }}
            >
              <SafeHtmlRenderer tag='div' className={style.horizontalScrollImgTitle} content={item.text || ''} />
              <ParallaxMedia onMove={true} src={item.src} src375={item.srcXS} className={style.horizontalScrollImg} />
              {viewport && (
                <NextImage
                  loading='lazy'
                  decoding='async'
                  src={!isMobile ? Gradient_5 : Gradient_4_mob}
                  alt='gradient'
                  className={style.horizontalScrollImgGradient}
                />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default HorizontalScroll;
